import React from 'react';
export function About() {
  return <section id="about" className="bg-swiss-gray border-b-2 border-black" data-id="element-21">
      <div className="container mx-auto px-0" data-id="element-22">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-23">
          {/* Image Side */}
          <div className="relative min-h-[500px] border-b-2 lg:border-b-0 lg:border-r-2 border-black overflow-hidden group" data-id="element-24">
            <img src="https://images.unsplash.com/photo-1558655146-d09347e0c766?q=80&w=1974&auto=format&fit=crop" alt="Office" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-25" />
            <div className="absolute inset-0 bg-black/20" data-id="element-26"></div>
            <div className="absolute bottom-8 left-8 bg-white border-2 border-black p-4 shadow-[4px_4px_0px_0px_#000000]" data-id="element-27">
              <p className="font-bold uppercase text-sm" data-id="element-28">New York City, NY</p>
            </div>
          </div>

          {/* Content Side */}
          <div className="p-8 lg:p-16 flex flex-col justify-center bg-white" data-id="element-29">
            <h2 className="text-4xl md:text-5xl font-heading font-black text-black uppercase mb-8" data-id="element-30">
              We Are
              <br data-id="element-31" />
              Pixel Perfect
            </h2>

            <p className="text-xl font-medium text-black mb-8 leading-relaxed" data-id="element-32">
              Founded in 2013, we are a collective of designers, developers, and
              strategists who believe that good design is honest, functional,
              and bold.
            </p>

            <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-33">
              <div data-id="element-34">
                <h3 className="text-4xl font-black text-swiss-red mb-2" data-id="element-35">10+</h3>
                <p className="font-bold uppercase text-sm" data-id="element-36">Years Experience</p>
              </div>
              <div data-id="element-37">
                <h3 className="text-4xl font-black text-swiss-red mb-2" data-id="element-38">
                  150+
                </h3>
                <p className="font-bold uppercase text-sm" data-id="element-39">
                  Projects Delivered
                </p>
              </div>
            </div>

            <div className="space-y-4 border-t-2 border-black pt-8" data-id="element-40">
              {['Strategy', 'Design', 'Technology'].map((item, i) => <div key={i} className="flex items-center gap-4 group cursor-default" data-id="element-41">
                  <div className="w-4 h-4 bg-black group-hover:bg-swiss-red transition-colors" data-id="element-42"></div>
                  <span className="text-lg font-bold uppercase tracking-wider" data-id="element-43">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}